// extracted by mini-css-extract-plugin
export default {"container":"VeriryNow_container__Byasu","text":"VeriryNow_text__uvCb4","button":"VeriryNow_button__8NQhG"};